module.exports = __webpack_public_path__ + "img/2020_1.19d92e00.webp";